import { BrainCircuit, Cog, Headset } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";

const schoolBenefits = [{
    icon: <Headset className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Proactive Support",
    description: "Fixes problems before they hurt learning.",
}, {
    icon: <BrainCircuit className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Human-aware AI",
    description: "Empathetic, stress-free automation.",
}, {
    icon: <Cog className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Transparent Operations",
    description: "You can see every action and change.",
}];


export default function FromChaos() {

    return (
        <Box
            badge={"WHY YOU NEED US"}
            title={"From Chaos to Clarity"}
            leftBlock={
                <div className='col-span-2 text-center space-y-10'>
                    <Text 
                        type="description" 
                        cName="mx-auto max-w-7xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium italic" 
                        label={"Every school starts with love and dreams — not money. But today, you handle so many things: attendance, transport, fees, exams, feedback, compliance. It’s not that schools are weak. It’s that old systems waste time."}
                    />
                    <Text 
                        type="description" 
                        cName="mx-auto max-w-7xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium italic" 
                        label={"SooMuch.ai changes that. It helps your school work smart, automatically. While teachers teach, AI handles the rest — attendance, homework, updates, and even fee reminders. You get back control, focus, and peace."}
                    />
                </div>
            }
        />
    );
}